<template>
    <div class="bg-mission-item rounded-lg my-8" data-cy="card_mission_game" v-if="game.length > 0 || game">
        <div class="box-mission grid items-center relative" data-cy="btn_mission_game_detail" @click="clickToDetail()">
            <div class="box-text p-4">
                <div class="font-bold text-18 text-a-white-ffffff pb-3">
                    {{ title }}
                </div>
                <div class="w-28 flex justify-center items-center bg-a-white-ffffff font-bold text-14 text-a-blue-2140a6 rounded-sm py-2.5"
                    v-if="!isWin && missionGameDate">
                    <div class="pr-3"><img :src="icPlayGame" /></div>
                    <div>{{ lbl.mission.play }}</div>
                </div>
                <div class="w-28 flex justify-center items-center bg-a-gray-c4c4c4 font-bold text-14 text-a-white-ffffff rounded-sm py-2.5"
                    v-else>
                    <div class="pr-3"><img :src="icPlayGameWin" /></div>
                    <div>{{ lbl.mission.play_success }}</div>
                </div>
                <div class="font-medium text-12 text-a-yellow-ffca66 pt-1" v-if="isWin">
                    {{ lbl.mission.play_win }}
                </div>
            </div>
            <div class="box-img absolute bottom-0 -right-3 my-auto justify-self-end">
                <img :src="imgGame" />
            </div>
        </div>
    </div>
</template>
<script>
//helper
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import ConfigManager from '@/config/ConfigManager.js';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
//service
import MissionService from '../../service/MissionService.js';

export default {
    name: 'MissionGame',
    mixins: [LocaleMixin, ModalMixin],
    props: {
        game: { type: Object, required: true }
    },
    data: function(){
        return {
            title: '',
            isWin: false,
            missionGameDate: false,
            icPlayGame: null,
            icPlayGameWin: null,
            imgGame: null,
        }
    },
    created: async function(){
        console.log('game', this.game);
        let game = await this.getMissionDetailBlob();
        this.checkGameWin();
        this.title = this.localeCode == 1054 ? game.title_th : game.title_en;
        this.imgUrl();
    },
    methods: {
        getMissionDetailBlob: function () {
            return new Promise((resolve) => {
                this.modal.loadingModal.show();
                MissionService.getMissionDetailConfig()
                    .subscribe({
                        next: (res) => {
                            // console.log('config', res)
                            this.modal.loadingModal.hide();
                            resolve(res.game);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            this.modal.loadingModal.hide();
                            resolve(null);
                        }
                    });
            });
        },
        checkGameWin: async function(){
            let gameConfig = await this.game;
            let currentDate = new Date();
            let start = DatetimeHelper.unixTimestampToDate(gameConfig.StartDate);
            let end = DatetimeHelper.unixTimestampToDate(gameConfig.EndDate);

            if (currentDate >= start  && currentDate <= end) {
                this.missionGameDate = true;
            }

            if (gameConfig.IsPlayed) {
                this.isWin = true;
            }
            // if (gameConfig.id == null || gameConfig.code == '404' ||
            //     gameConfig.message == 'game not found') {
            //     this.isWin = true;
            // }
            // if (gameConfig.TracePlan != null)  {
            //     this.isWin = false;
            // }
        },
        clickToDetail: function(){
            if(this.isWin) return;

            this.tracking.event('mission_game', 'mission_game', null, null);
            this.$router.push('/mission/detailandcondition/game');
        },
        imgUrl: function() {
            var appId = ConfigManager.getAppId();
            this.imgGame = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/img-game.png`;
            this.icPlayGame = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/ic-play-game.png`;
            this.icPlayGameWin = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/ic-play-game-win.png`;
        },
    }
}
</script>
<style lang="scss" scoped>
.box-mission{
    min-height: 180px;

    .box-text{
        width: 55%;
    }
    .box-img{
        width: 45%;
    }
}
</style>

